import {
    getAvailableBarcodes,
    getAvailableFonts,
    getAvailableFontSizes
} from "../selectors/defaultSelectors";

const editor = {
    loading: true,
    textColour: 'white',
    activeColour: 'black',
    printSide: 'Front',
    activeLayer: false,
    canvas: false,
    printingOffset: {
        // For printing
        topLeftX: 0,
        topLeftY: 0,
        bottomRightX: 0,
        bottomRightY: 0,
    },
    textOrientations: [
        {
            label: 'Up',
            value: 'up',
        },
        {
            label: 'Down',
            value: 'down',
        },
    ],
    textAlignments: [
        {
            label: 'Center',
            value: 'center',
        },
        {
            label: 'Left',
            value: 'left',
        },
        {
            label: 'Right',
            value: 'right',
        },
    ],
    displays: [
        {
            name: 'Characters',
            icon: `${window.pathURL}img/temp/editor/tb-tag-characters.png`,
        },
        {
            name: 'Graphic',
            icon: `${window.pathURL}img/temp/editor/tb-tag-graphic.png`,
        },
    ],
    barcodeTypes: getAvailableBarcodes(),
    fonts: getAvailableFonts(),
    fontSizes: getAvailableFontSizes(),
    // This holds the base data that will be used to clean editor state
    baseData: {
        editor: null,
        nlis: null,
    },
};
const EditorReducer = function(state = editor, action) {
    switch (action.type) {
        case 'TOGGLE_EDITOR_LOADING': {
            return {
                ...state,
                loading: action.value,
            };
        }
        case 'SET_BASE_TAG_DATA': {
            return {
                ...state,
                baseData: {
                    ...state.baseData,
                    [action.key]: action.data,
                },
            };
        }
        case 'SET_TAG_DATA': {
            return {
                ...state,
                ...action.data,
            };
        }
        case 'SET_CANVAS': {
            return {
                ...state,
                canvas: {
                    ...state.canvas,
                    [action.side]: action.value,
                },
            };
        }
        case 'RESET_CANVAS': {
            return {
                ...state,
                canvas: false,
            };
        }
        case 'TOGGLE_SIDES': {
            const { side } = action;
            return {
                ...state,
                activeLayer: false,
                sides: {
                    ...state.sides,
                    [side]: {
                        ...state.sides[side],
                        active: !state.sides[side].active,
                    },
                },
            };
        }

        case 'SET_PRINT_SIDE': {
            const { side } = action;
            const sideID = side.toLowerCase();

            return {
                ...state,
                printSide: side,
                sides: {
                    ...state.sides,
                    [sideID]: {
                        ...state.sides[sideID],
                        active: true,
                    },
                },
            };
        }

        case 'TOGGLE_PRINTSIDES': {
            const { side } = action;
            return {
                ...state,
                activeLayer: false,
                printSide: side,
                // printSides: {
                //   side
                //   // [side]: {
                //   //   ...state.sides[side],
                //   //   active: !state.sides[side].active
                //   // }
                // }
            };
        }

        case 'REVEAL_BACKSIDE': {
            return {
                ...state,
                revealBackSideBool: !state.revealBackSideBool,
            };
        }

        case 'DELETE_PRTINTSIDE': {
            const deleteSide = action.side.toLowerCase();
            let filtered = Object.keys(state.sides)
                .filter((key) => !deleteSide.includes(key))
                .reduce((obj, key) => {
                    obj[key] = state.sides[key];
                    return obj;
                }, {});

            return {
                ...state,
                sides: filtered,
            };
        }
        case 'CHANGE_SIDE_MASK': {
            const { side, clippingMask } = action;

            return {
                ...state,
                sides: {
                    ...state.sides,
                    [side]: {
                        ...state.sides[side],
                        clippingMask: clippingMask
                    }
                },
            };
        }
        case 'TOGGLE_REGIONS': {
            const { region } = action;
            return {
                ...state,
                regions: {
                    ...state.regions,
                    [region]: {
                        ...state.regions[region],
                        active: !state.regions[region].active,
                    },
                },
            };
        }
        case 'CHANGE_REGION_STYLE': {
            const { region, style } = action;
            return {
                ...state,
                regions: {
                    ...state.regions,
                    [region]: {
                        ...state.regions[region],
                        activeStyle: style,
                    },
                },
            };
        }
        case 'REMOVE_TAG_STYLE': {
            const { region, style } = action;

            let stateRegions = {
                ...state.regions,
                [region]: {
                    ...state.regions[region],
                    styles: state.regions[region].styles.reduce((newStyles, currentStyle) => {
                        if (currentStyle !== style) {
                            newStyles.push(currentStyle);
                        }

                        return newStyles;
                    }, [])
                }
            };

            if(stateRegions[region].activeStyle === style && stateRegions[region].styles.length > 0) {
                stateRegions[region].activeStyle = stateRegions[region].styles[0];
            }

            let stateStyles = Object.values(state.styles).reduce((newStyles, currentStyle) => {
                if (currentStyle.id !== style) {
                    newStyles[currentStyle.id] = currentStyle;
                }

                return newStyles;
            }, {});
            let stateLayers = Object.values(state.layers).reduce((newLayers, currentLayer) => {
                const currentStyle = currentLayer.style;
                if(currentStyle !== style) {
                    newLayers[currentLayer.id] = currentLayer;
                }

                return newLayers;
            }, {});

            return {
                ...state,
                regions: {
                    ...state.regions,
                    ...stateRegions
                },
                styles: {
                    ...state.styles,
                    ...stateStyles
                },
                layers: {
                    ...state.layers,
                    ...stateLayers
                }
            };
        }
        case 'CHANGE_LAYER_TYPE_FIELD': {
            const { layer, target, value } = action;
            const { activeType } = state.layers[layer];
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        types: {
                            ...state.layers[layer].types,
                            [activeType]: {
                                ...state.layers[layer].types[activeType],
                                fields: {
                                    ...state.layers[layer].types[activeType]
                                        .fields,
                                    [target]: value,
                                },
                            },
                        },
                    },
                },
            };
        }
        case 'ADD_LAYER_TYPE': {
            const { layer, tagTypeKey, tagType } = action;

            let newLayers = {
                ...state.layers,
            };

            if( typeof(newLayers[layer]) != 'undefined' &&
                typeof(newLayers[layer].types[tagTypeKey]) == 'undefined') {
                newLayers[layer].types[tagTypeKey] = {
                    ...newLayers[layer].types[tagTypeKey],
                    ...tagType
                };
            }

            return {
                ...state,
                layers: newLayers,
            };
        }
        case 'REMOVE_LAYER_TYPE': {
            const { layer, target } = action;

            let newLayers = {
                ...state.layers,
            };

            if( typeof(newLayers[layer]) != 'undefined' &&
                typeof(newLayers[layer].types[target]) != 'undefined') {
                delete newLayers[layer].types[target];
            }

            return {
                ...state,
                layers: newLayers,
            };
        }
        case 'CHANGE_LAYER_FIELD': {
            const { layer, target, value } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        [target]: value,
                    },
                },
            };
        }
        case 'CHANGE_LAYER_SCALE': {
            const { layer, scale } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        scale: scale,
                    },
                },
            };
        }
        case 'CHANGE_LAYER_MAX_WIDTH': {
            const { layer, maxWidth } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        layerMaxWidth: maxWidth,
                    },
                },
            };
        }
        case 'CHANGE_LAYER_EXTRA_SETTINGS': {
            const { layer, params } = action;
            const currentSettings = state.layers[layer].extraSettings || {};

            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        extraSettings: {
                            ...currentSettings,
                            ...params,
                        },
                    },
                },
            };
        }
        case 'CHANGE_LAYER_ROTATION': {
            const { layer, rotation } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        rotation: rotation,
                    },
                },
            };
        }
        case 'CHANGE_LAYER_TEXTORIENTATION': {
            const { layer, textOrientation } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        textOrientation: textOrientation,
                    },
                },
            };
        }
        case 'CHANGE_LAYER_POSITION': {
            const { layer, position } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        position: position,
                    },
                },
            };
        }
        case 'CHANGE_TAG_COLOUR': {
            const { tagColour, textColour } = action;

            return {
                ...state,
                activeColour: tagColour,
                textColour: textColour,
            };
        }
        case 'CHANGE_FONT_COLOUR': {
            const { tagColour, textColour } = action;

            return {
                ...state,
                activeColour: tagColour,
                textColour: textColour,
            };
        }
        case 'UPDATE_EDITOR': {
            return {
                ...state,
                [action.target]: action.value,
            };
        }
        case 'SELECT_LAYER': {
            return {
                ...state,
                activeLayer: action.layer,
            };
        }
        case 'SAVE_FONT': {
            return {
                ...state,
                fonts: {
                    ...state.fonts,
                    [action.id]: {
                        ...state.fonts[action.id],
                        curves: action.font,
                    },
                },
            };
        }
        case 'ADD_LAYER': {
            const { style, layer } = action;
            const id = Object.keys(layer)[0];
            return {
                ...state,
                // activeLayer: action.layer,
                activeLayer: id,
                // activeLayer: false,
                layers: {
                    ...state.layers,
                    [id]: Object.values(layer)[0],
                },
                styles: {
                    ...state.styles,
                    [style]: {
                        ...state.styles[style],
                        layers: [...state.styles[style].layers, id],
                    },
                },
            };
        }
        case 'REMOVE_LAYER': {
            const { layers } = state;
            const { layer } = action;
            const { style } = layers[layer];
            const { [layer]: removedItem, ...otherLayers } = layers;
            return {
                ...state,
                activeLayer: false,
                layers: otherLayers,
                styles: {
                    ...state.styles,
                    [style]: {
                        ...state.styles[style],
                        layers: state.styles[style].layers.filter(
                            (item) => item !== layer
                        ),
                    },
                },
            };
        }
        case 'ADD_LAYER_ERROR': {
            const { layer, target, message } = action;
            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        errors: {
                            ...state.layers[layer].errors,
                            [target]: {
                                message: message,
                            },
                        },
                    },
                },
            };
        }
        case 'REMOVE_LAYER_ERROR': {
            const { layers } = state;
            const { layer, target } = action;
            const { [target]: removedError, ...otherErrors } =
                layers[layer].errors || false;

            return {
                ...state,
                layers: {
                    ...state.layers,
                    [layer]: {
                        ...state.layers[layer],
                        errors: otherErrors,
                    },
                },
            };
        }
        case 'CHANGE_TAG_TYPE': {
            // NOTE: remove in prod
            return {
                ...state,
                group: action.value,
            };
        }
        default: {
            return state;
        }
    }
};

export default EditorReducer;
